import { createReducer, on } from '@ngrx/store';
import {
  LatestDeviceDiagnosticsActions,
  LatestDeviceDiagnosticsApiActions,
  LatestDeviceDiagnosticsSignalRActions,
} from './latest-device-diagnostics.actions';
import { adapter, initialState } from './latest-device-diagnostics.state';

export const latestDeviceDiagnosticsFeatureKey = 'latestDeviceDiagnostics';

export const latestDeviceDiagnosticsReducer = createReducer(
  initialState,
  on(LatestDeviceDiagnosticsApiActions.latestDeviceDiagnosticsLoaded, (state, { diagnostics }) =>
    adapter.setAll(diagnostics, state)
  ),
  on(LatestDeviceDiagnosticsSignalRActions.latestDeviceDiagnosticUpdated, (state, { diagnostic }) =>
    diagnostic.udid ? adapter.upsertOne(diagnostic, state) : state
  ),
  on(LatestDeviceDiagnosticsActions.latestDeviceDiagnosticsCleared, (state) => adapter.removeAll(state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectLatestDeviceDiagnosticIds = selectIds;
export const selectLatestDeviceDiagnosticEntities = selectEntities;
export const selectAllLatestDeviceDiagnostics = selectAll;
